import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import './assets/styles/font.css'
import './assets/styles/global.css'
import './assets/styles/detail.css'

loadFonts()

const app = createApp(App)
app.use(router)
app.use(vuetify)
app.mount('#app')

// MockApi
import MockApi from './APIMock.js'
app.config.globalProperties.$MockApi = MockApi
